var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sfcStartNodeContainer",class:{ vertical: _vm.vertical }},[_c('div',{staticClass:"sfcStartNodeContent"},[_vm._v(_vm._s(_vm.data.title))]),_c('SFCArrowLine'),_c('SFCAddNode',{attrs:{"nodeList":_vm.nodeList,"nodeData":_vm.data,"btnType":_vm.isMouseEnter ? 'dot' : ''}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }